import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "feed-desktop-aside" }
const _hoisted_2 = {
  key: 0,
  class: "feed-widget-card feed-widget-card--highlight"
}
const _hoisted_3 = { class: "feed-widget-card__body" }
const _hoisted_4 = { class: "feed-widget-card feed-widget-card--muted" }
const _hoisted_5 = { class: "feed-widget-card__links" }

import {useIonRouter} from '@ionic/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsDesktopSidebar',
  props: {
  pendingResponses: {
    type: Number,
    default: 0,
  },
},
  emits: ["select-tab"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const ionRouter = useIonRouter();

const goTo = (name: string) => {
  ionRouter.navigate({name}, 'forward', 'push');
};

const goToHosting = () => {
  emit('select-tab', 'my-events');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    (__props.pendingResponses)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "feed-widget-card__title" }, "Pending responses", -1)),
          _createElementVNode("p", _hoisted_3, " You have " + _toDisplayString(__props.pendingResponses) + " invite " + _toDisplayString(__props.pendingResponses === 1 ? 'request' : 'requests') + " waiting on your hosted events. ", 1),
          _createElementVNode("button", {
            type: "button",
            class: "feed-widget-link",
            onClick: goToHosting
          }, "Review hosting")
        ]))
      : _createCommentVNode("", true),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "feed-widget-card" }, [
      _createElementVNode("div", { class: "feed-widget-card__title" }, "Hosting tips"),
      _createElementVNode("p", { class: "feed-widget-card__body" }, " Add a cover photo, set a clear capacity, and share early so members can mark themselves interested. ")
    ], -1)),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "feed-widget-card__title" }, "Explore more", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: "feed-widget-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goTo('Feed')))
        }, "Back to feed"),
        _createElementVNode("button", {
          type: "button",
          class: "feed-widget-link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo('Search')))
        }, "Find members"),
        _createElementVNode("button", {
          type: "button",
          class: "feed-widget-link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo('Flirt')))
        }, "Open chat")
      ])
    ])
  ]))
}
}

})